import {createSelector} from 'reselect';
import MessageType from '../../../../enums/MessageType';
import {generateBooleanSelector} from '../../SelectorGenerator';
import {getSelectedDeliveryCountry, isCreditUsed} from '../../selectors';

export const getAdyenKlarnaErrorMessage = createSelector(
  [getSelectedDeliveryCountry, isCreditUsed],
  (deliveryCountry, creditUsed) => {
    if (['AT', 'DE', 'NL', 'DK', 'FI', 'NO', 'SE'].indexOf(deliveryCountry) === -1) {
      return {type: MessageType.INFO, translationKey: 'klarna.payments.ineligible.message'};
    }
    
    if (creditUsed) {
      return {type: MessageType.INFO, translationKey: 'klarna.payments.credit.message'};
    }
    
    return null;
  },
);

export const getAdyenKlarnaIsDisabled = generateBooleanSelector(getAdyenKlarnaErrorMessage);
